import { useState } from "react";

function ActivityDebugItem({ a }) {
  const [expanded, setExpanded] = useState(false);

  const iconClass =
    a.mediumType === "SMS"
      ? "bi-chat-text-fill text-primary"
      : a.mediumType === "EMAIL"
      ? "bi-envelope-fill text-info"
      : a.mediumType === "CALL"
      ? "bi-telephone-fill text-success"
      : "bi-question-circle text-muted";

  return (
    <li className="list-group-item py-3 px-4">

      {/* ==============================
          TOP HEADER (COMPACT VIEW)
         ============================== */}
      <div className="d-flex justify-content-between align-items-start">
        
        {/* LEFT HEADER CONTENT */}
        <div className="d-flex align-items-start gap-3">
          <i className={`${iconClass} fs-3`}></i>

          <div>
            <div className="fw-bold fs-6 mb-1">
              {a.activityName}
            </div>

            <div className="text-muted small">
              Patient: <strong>{a.patientName}</strong>
            </div>

            <div className="text-muted small">
              Created: {a.createdAt}
            </div>

            <div className="text-muted small">
              Modified: {a.modifiedAt}
            </div>
          </div>
        </div>

        {/* STATUS + EXPAND BUTTON */}
        <div className="text-end">

          <span
            className={`badge ${
              a.status === "SENT"
                ? "bg-success"
                : a.status === "FAILED"
                ? "bg-danger"
                : "bg-secondary"
            } fs-6 mb-2`}
          >
            {a.status}
          </span>

          <br />

          <button
            className="btn btn-sm btn-outline-primary mt-1"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? (
              <>
                <i className="bi bi-chevron-up me-1"></i> Hide Details
              </>
            ) : (
              <>
                <i className="bi bi-chevron-down me-1"></i> Show Details
              </>
            )}
          </button>
        </div>

      </div>

      {/* ==============================
          DETAILS VIEW (EXPANDABLE)
         ============================== */}
      {expanded && (
        <div className="mt-4 border-top pt-4">

          {/* Row 1: Activity Info */}
          <h6 className="text-uppercase text-muted small fw-bold">Activity Info</h6>
          <div className="border rounded p-3 bg-light small mb-3">
            <div><strong>ID:</strong> {a.id}</div>
            <div><strong>Category:</strong> {a.category}</div>
            <div><strong>Medium Type:</strong> {a.mediumType}</div>
            <div><strong>Status Code:</strong> {a.statusCode}</div>
            <div><strong>Queue ID:</strong> {a.queueId}</div>
            <div><strong>Reminder Type ID:</strong> {a.reminderTypeId}</div>
          </div>

          {/* Row 2: Patient Info */}
          <h6 className="text-uppercase text-muted small fw-bold">Patient Info</h6>
          <div className="border rounded p-3 bg-light small mb-3">
            <div><strong>Patient ID:</strong> {a.patientId}</div>
            <div><strong>Name:</strong> {a.patientName}</div>
            <div><strong>First Name:</strong> {a.firstName}</div>
            <div><strong>Last Name:</strong> {a.lastName}</div>
            <div><strong>Preferred Name:</strong> {a.preferredName}</div>
            <div><strong>Receiver:</strong> {a.receiver}</div>
          </div>

          {/* Row 3: System Info */}
          <h6 className="text-uppercase text-muted small fw-bold">System Info</h6>
          <div className="border rounded p-3 bg-light small mb-3">
            <div><strong>Clinic ID:</strong> {a.clinicId}</div>
            <div><strong>User ID:</strong> {a.userId}</div>
          </div>

          {/* Row 4: Content */}
          <h6 className="text-uppercase text-muted small fw-bold">Content</h6>
          <pre className="border rounded bg-white p-3 small mb-3" style={{ maxHeight: "200px", overflow: "auto" }}>
            {a.content ? a.content : "No content"}
          </pre>

          {/* Row 5: Extra Info */}
          <h6 className="text-uppercase text-muted small fw-bold">Extra Info</h6>
          <pre className="border rounded bg-white p-3 small" style={{ maxHeight: "200px", overflow: "auto" }}>
            {a.extraInfo ? JSON.stringify(a.extraInfo, null, 2) : "No extra info"}
          </pre>

        </div>
      )}

    </li>
  );
}

export default ActivityDebugItem;
